import { forwardRef, type Ref, type SVGProps } from "react";
const IconFileFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M17 11V2H7a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V12h-9a1 1 0 0 1-1-1m-7 4h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m12 10H10a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2m1-5a1 1 0 0 1-1 1H10a1 1 0 0 1 0-2h12a1 1 0 0 1 1 1" />
    <path d="M26.8 10a3.4 3.4 0 0 0-.8-1.4l-.3-.3-5-5-.3-.3a3.4 3.4 0 0 0-1.4-.8V10z" />
  </svg>
);
const ForwardRef = forwardRef(IconFileFilledSVG);
ForwardRef.displayName = "IconFileFilled";
export { ForwardRef as IconFileFilled };
